 <script setup>

</script>

<template>
  <div class="home">
      <button class="back mt-4" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
      </svg>Retour</button>
      <div class="container my-5">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
             <div class="col-lg-6">
              <div class="infos">
                <p class="titre">AFFAIRE : <strong>{{ naf }}</strong></p>
                <p><strong>{{ piece }}</strong></p>
                <p style="font-weight: 600;" v-if="designation.trim() != '' && designation.trim() != 'empty'">{{ designation }}</p>
              <p style="font-weight: 600;" v-if="designation2.trim() != '' && designation2.trim() != 'empty'">{{ designation2 }}</p>
              <p style="font-weight: 600;" v-if="designation3.trim() != '' && designation3.trim() != 'empty'">{{ designation3 }}</p>
              </div>
            
             </div>
             <div class="col-lg-6">
              <div class="infos_affaire">
                <p>Commande client : {{ cocde }}</p>
                <p>Quantité à produire : {{ qte }}</p>
                 <p>Délais de production interne : {{ formatDate(delais_interne) }}</p>
                <p>Délais de production : {{ formatDate(delais) }}</p>
              </div>
             </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="clientContainer">
            <img class="barcode" alt='Barcode Generator TEC-IT'
            :src="'https://barcode.tec-it.com/barcode.ashx?data=0000' + naf + '&code=Code39&multiplebarcodes=true'"/>
            <img class="logoClient" :src="'https://www.simef.fr/espace-client/espaces-perso/clients/' + client + '/logos/logo.jpg?' + Date.now()" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="fichiersAcces encart">
            <h2>Fichiers Disponibles</h2>
            <RouterLink :to="'/fichiers-client/' + clientName"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>Fichiers et photos du client</RouterLink>
            <RouterLink :to="'/fichiers-affaire/' + naf"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>Fichiers et photos de l'affaire</RouterLink>
          </div>
        </div>
      </div>
    </div>


    
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';


export default {
  data() {
      return {
        designation: null,
        designation2: null,
        designation3: null,
        naf: null,
        utilisateur: '',
        loggedInRole: null,
        loggedInEmail: null,
        utilisateursSelectionnes: [],
        nomFichier: '',
        fichiers: [],
        confirmationMessage: '',
        errorMessage: '',
        confirmationMessageCom: '',
        errorMessageCom: '',
        cocde: '',
        piece: '',
        qte: '',
        delais: '',
        delais_interne: '',
        duree: '',
        quantite: '',
        client: '',
        etat: 'Production partielle',
        clientName: '',
        message_interne: '',
        message_externe: '',
        userRole: 'gestion',
        commentaire_motif: '',
        dispo: ''
      };
  },
  mounted() {
      // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        affaire: this.naf
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data.split(',');
        //console.log(this.utilisateursSelectionnes);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
      

      axios.post('https://www.simef.fr/espace-client/api/getAffaireSoldee.php', {
        naf: this.naf
      })
      .then(response => {
        this.cocde = response.data[0].cocde;
        this.piece = response.data[0].piece;
        this.qte = response.data[0].qte;
        this.delais = response.data[0].delais;
        this.delais_interne = response.data[0].delais_interne;
        this.message_interne = response.data[0].message_interne;
        this.message_externe = response.data[0].message_externe;
      })
      .catch(error => {
          console.error(error);
      });


      axios.post('https://www.simef.fr/espace-client/api/getDispos.php', {
        naf: this.naf
      })
      .then(response => {
        this.dispo = response.data;
      })
      .catch(error => {
          console.error(error);
      });

      
      
      
  },
  created() {
        this.designation = this.$route.params.designation;
        this.designation2 = this.$route.params.designation2;
        this.designation3 = this.$route.params.designation3;
        this.naf = this.$route.params.naf
        this.client = this.$route.params.client;

        

        axios.post('https://www.simef.fr/espace-client/api/getClientName.php', {
          client: this.client
        })
        .then(response => {
          this.clientName = response.data.nom;
        })
        .catch(error => {
            console.error(error);
        });
    },
  methods: {
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
    /*submit() {
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      formData.append('nomFichier', this.nomFichier);
      formData.append('utilisateur', this.utilisateur);
      formData.append('naf', this.naf);

      
      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersAffaires.php', formData)
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.fichiers = [];
          this.nomFichier = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    }*/
    submitProd() {
      axios.post('https://www.simef.fr/espace-client/api/ajoutDonneeProduction.php', {
        naf: this.naf,
        etat: this.etat,
        utilisateur: this.loggedInEmail,
        nomPrenom: this.utilisateur, 
        duree: this.duree,
        quantite: this.quantite,
        utilisateursSelectionnes: this.utilisateursSelectionnes,
        desa1: this.designation,
        desa2: this.designation2,
        desa3: this.designation3,
        commandeClient: this.cocde,
        qte: this.qte,
        delais: this.formatDate(this.delais)
      })
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.duree = '';
          this.quantite = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    submitCom() {
      axios.post('https://www.simef.fr/espace-client/api/sendEmail.php', {
       userRole: this.userRole,
       commentaire_motif: this.commentaire_motif,
       utilisateur: this.utilisateur, 
       affaire: this.naf,
      })
      .then(response => {
          this.confirmationMessageCom = response.data.success;
          this.errorMessageCom = response.data.error;
          this.userRole = 'gestion';
          this.commentaire_motif = '';
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    }
  }
}
</script>

<style lang="scss">
.infos_affaire {
  display: flex;
  flex-direction: column;
  a {
    padding: 8px 25px !important;
    margin-top: 15px;
    font-weight: 500;
    background: #2b358d !important;
    color: #fff!important;
    margin-bottom: 10px;
    align-items: center;
    width: fit-content;
    &:hover {
      color: #fff;
    }
    svg {
      margin-right: 15px;
    }
  }
}
.infos_affaire {
  text-align: left;
  @media screen and (max-width:992px) {
    text-align: center;
  }
  .titre {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 0px;
  }
}

.barcode {
  height: 70px;
  margin-bottom: 20px;
}

form {
  input, select {
    margin-bottom: 10px!important;
  }
}

button.back {
  display: inherit;
  margin: auto;
  margin-bottom: 20px!important;
  display: flex;
  align-items: center;
 }

 @media screen and (max-width:992px) {
    .back {
      margin-top: 30px!important;
    }
 }
 button.back svg {
  height: 24px;
  width: 24px;
  margin-right: 6px;
 }

 .usersList {
  text-align: left;
  margin: 0px;
  list-style: none;
  padding: 0px;
  a {
    font-weight: 500;
    display: flex;
    align-items: center;
    color: #1d1d20;
    svg {
      margin-right: 10px;
      height: 17px;
      width: 17px;
    }
  }
 }
.logoClient {
  height: 50px;
}
.small {
  font-size: 0.7rem;
  font-style: italic;
  margin-bottom: 0px;
}

.clientContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
@media screen and (max-width:992px) {
  .clientContainer {
    margin-top: 30px;
  }
}
.prog {
  text-align: center;
  width: 60%;
  p {
    margin: 0px;
    margin-bottom: 2px;
    font-size: 0.7rem;
  }
}
.progress-bar {
  width: 100%; /* Ajustez la largeur selon votre mise en page */
  height: 8px; /* Ajustez la hauteur selon votre mise en page */
  background-color: #e0e0e0!important; /* Couleur de fond de la barre */
  span {
    background: #2b358d;
    height: 100%;
  }
}
</style>
